import { view } from '@yola/ws-sdk';
import {
  XL_BREAKPOINT_PX,
  MD_BREAKPOINT_PX,
} from 'src/js/modules/breakpoint-editing/constants/breakpoints';
import isTouchDevice from '../verifiers/is-touch-device';

const { deviceModes, deviceModeBreakpoints, breakpointModifiers } = view;

const getBreakpointForCurrentDevice = (modifier = breakpointModifiers.DOWN) => {
  const isTouchableDevice = isTouchDevice();

  if (isTouchableDevice) {
    const isMobileWidth = window.innerWidth < MD_BREAKPOINT_PX;

    if (isMobileWidth) {
      return deviceModeBreakpoints[deviceModes.MOBILE][modifier];
    }

    const isTabletWidth = window.innerWidth < XL_BREAKPOINT_PX;

    if (isTabletWidth) {
      return deviceModeBreakpoints[deviceModes.TABLET][modifier];
    }
  }

  return view.accessors.getBreakpointByDeviceMode(modifier);
};

export default getBreakpointForCurrentDevice;
